module.exports = __webpack_public_path__ + "img/user.353eaa56.png";